module.exports = __webpack_public_path__ + "img/copSolid.2e42cf48.svg";